import { Button, Icon, Tooltip } from '@zoom/components';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { CALENDAR_EXPORT_CONTENT, CALENDAR_EXPORT_TOGGLE_BUTTON } from '../../constants';

type CalendarExportButtonProps = {
  active: boolean;
  onClick: (active: boolean) => void;
};

export const CalendarExportButton: React.FC<CalendarExportButtonProps> = ({ active, onClick }) => {
  const { t } = useTranslation();

  return (
    <Tooltip message={t('calendar.export.title')} placement="bottom">
      <Button
        active={active}
        aria-expanded={active}
        aria-label={t('calendar.export.title')}
        aria-controls={CALENDAR_EXPORT_CONTENT}
        className="calendar-export-button"
        color="info"
        data-test-id={CALENDAR_EXPORT_TOGGLE_BUTTON}
        id={CALENDAR_EXPORT_TOGGLE_BUTTON}
        onClick={() => onClick(!active)}
      >
        <Icon color="#239ed8" kind="link" size={28} />
      </Button>
    </Tooltip>
  );
};
